module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-report-1.05a8e436.svg";